import styles from "./styles/radio_button.module.scss";

export function RadioButton(props: { label: string; name: string; checked?: boolean }) {
  return (
    <div className={styles.radioButton}>
      <input
        className={styles.input}
        type="radio"
        name={props.name}
        checked={props.checked}
        value={props.label}
      />
      <label className={styles.label}>{props.label}</label>
    </div>
  );
}
